"use client";

import { c as _c } from "react/compiler-runtime";
import { Heart } from "lucide-react";
import { forwardRef, useState } from "react";
import WithAuth from "../../hoc/WithAuth";
import { cn } from "@/lib/utils";
import FavoriteMenuContent from "./FavoriteMenuContent";
import { ModalTypeEnum, useModal } from "@/components/providers/modal-provider/ModalProvider";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslations } from "next-intl";
type Props = {
  realEstateId: string;
  realEstateSlug: string;
  favorite?: boolean;
  className?: string;
  fill?: string;
  onClick?: (e: React.MouseEvent) => void;
};
export default forwardRef<HTMLButtonElement, Props>(function CardFavorite(t0, ref) {
  const $ = _c(13);
  const {
    realEstateId,
    favorite,
    className,
    fill
  } = t0;
  const isMobile = useIsMobile();
  const {
    openModal
  } = useModal();
  const t = useTranslations("modules.favorites.modal");
  let t1;
  if ($[0] !== isMobile || $[1] !== openModal || $[2] !== realEstateId || $[3] !== t) {
    t1 = e => {
      e?.stopPropagation();
      e?.preventDefault();
      if (isMobile) {
        openModal(ModalTypeEnum.GENERIC_DRAWER, {
          children: <><div tabIndex={-1} /><FavoriteMenuContent realEstateId={realEstateId} /></>,
          title: t("title"),
          description: t("description")
        });
      } else {
        openModal(ModalTypeEnum.GENERIC_DIALOG, {
          children: <><div tabIndex={-1} /><FavoriteMenuContent realEstateId={realEstateId} /></>,
          title: t("title"),
          description: t("description")
        });
      }
    };
    $[0] = isMobile;
    $[1] = openModal;
    $[2] = realEstateId;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const toggleFavoriteMenu = t1;
  const preventDefault = _temp;
  let t2;
  if ($[5] !== className || $[6] !== favorite || $[7] !== fill || $[8] !== ref) {
    t2 = t3 => {
      const {
        onClick
      } = t3;
      return <button ref={ref} type="button" onClick={onClick} onMouseDown={preventDefault} onMouseUp={preventDefault} className={cn("relative cursor-pointer p-0 w-6 h-6", className)} tabIndex={0} aria-label="Toggle favorite"><Heart fill={favorite ? "red" : fill ?? "#00000066"} className={cn("w-6 h-6 text-white", "transition-all duration-150 ease-in-out", "hover:scale-110", "active:scale-90", className)} /></button>;
    };
    $[5] = className;
    $[6] = favorite;
    $[7] = fill;
    $[8] = ref;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t2 || $[11] !== toggleFavoriteMenu) {
    t3 = <WithAuth defaultOnClick={toggleFavoriteMenu}>{t2}</WithAuth>;
    $[10] = t2;
    $[11] = toggleFavoriteMenu;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
});
function _temp(e_0) {
  e_0?.stopPropagation();
  e_0?.preventDefault();
}